import React from 'react';

import ListSelect from '../generic/ListSelect';
import { FILTER_TYPES } from '../generic/Table/utils';
import { InfoTooltip } from '../generic/Tooltip';
import { UserLink } from '../users/Link';
import {
  boolColumnWithFilter,
  dateRangeColumn,
  simpleColumn,
} from '../utils/column-helpers';
import { name } from '../utils/columns';
import HELP_TEXTS from './help-texts';
import { MerchantLink } from './Link';

export const nameLink = {
  Header: 'Merchant',
  accessor: 'name',
  Cell: row => <MerchantLink model={row.original} />,
  Filter: props => <ListSelect {...props} type="allZmsamMerchant" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'id',
  sortable: false,
  width: 240,
};

export const merchantId = {
  Header: 'Merchant ID',
  accessor: 'merchantId',
  sortable: false,
};

export const pcName = {
  Header: 'Partner Consultant',
  accessor: 'pc',
  Cell: row => (row.value ? <UserLink model={row.value} /> : null),
  Filter: props => <ListSelect {...props} type="user" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'pcId',
  sortable: false,
};

export const managedServiceSalesUnit = {
  Header: 'Managed Service Sales Unit',
  accessor: 'pc.salesUnit',
  Cell: row => <span>{row?.value}</span>,
  sortable: false,
};

export const managedServiceSalesTeam = {
  Header: 'Managed Service Sales Team',
  accessor: 'salesTeam',
  Cell: row => <span>{row?.value}</span>,
  filterKey: 'pc__salesTeam',
  sortable: false,
};

export const selfServiceSalesUnit = {
  Header: 'Self Service Sales Unit',
  accessor: 'salesUnit',
  sortable: false,
};

export const framework = {
  Header: 'Merchant Framework',
  accessor: 'framework',
  sortable: false,
};

export const creationDate = dateRangeColumn(
  () => (
    <>
      <span id="created-header">Created At</span>
      <span>
        <InfoTooltip target="opp-expected-revenue">
          {HELP_TEXTS.info.created}
        </InfoTooltip>
      </span>
    </>
  ),
  'created',
  110,
  true,
  'Created At',
);

export const selfServiceActivated = boolColumnWithFilter(
  'Self Service Activated',
  'isSelfService',
  120,
);

export const hybridPartnerActivated = boolColumnWithFilter(
  'Hybrid Partner Activated',
  'isHybridPartner',
  120,
);

export const merchantGroupName = simpleColumn(
  'Merchant Group Name',
  'merchantGroupName',
  120,
);

export const merchantGroupId = {
  Header: 'Merchant Group Id',
  accessor: 'merchantGroupId',
  sortable: false,
  width: 120,
};

export const createdBy = simpleColumn('Created By', 'recordCreatedBy', 100);

export const companyName = simpleColumn('Company Name', 'companyName', 100);

// Not yet in the BE
// export const taxId = simpleColumn('Tax ID', 'taxId', 100);

export const vatId = simpleColumn('Vat ID', 'vatId', 100);

export const supplierCode = simpleColumn('Supplier Code', 'supplierCode', 100);

export const merchantType = simpleColumn('Merchant Type', 'merchantType', 100);

export const countries = {
  Header: 'Countries',
  accessor: 'countries',
  width: 100,
  Cell: row => row.value.join(', '),
  sortable: false,
};

export const billingEntityLink = {
  Header: 'Billing Entity',
  accessor: 'invoiceBillingEntity',
  Cell: row => (row.value ? <MerchantLink model={row.value} /> : ''),
  Filter: props => <ListSelect {...props} type="allZmsamMerchant" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'id',
  sortable: false,
  width: 240,
};

export const sapId = {
  Header: 'SAP ID',
  accessor: 'sapId',
  sortable: false,
};

export const businessModel = {
  Header: 'Business Model',
  accessor: 'businessModel',
  sortable: false,
};

export const merchantAssociationListColumns = [name];

export const listColumns = [
  nameLink,
  merchantId,
  pcName,
  countries,
  managedServiceSalesUnit,
  managedServiceSalesTeam,
  selfServiceSalesUnit,
  framework,
  selfServiceActivated,
  creationDate,
  hybridPartnerActivated,
  createdBy,
  merchantGroupName,
  merchantGroupId,
  merchantType,
  companyName,
  // taxId,
  vatId,
  supplierCode,
  billingEntityLink,
  sapId,
  businessModel,
];
